import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async'; 
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider> 
      <App />
    </HelmetProvider> 
  </React.StrictMode>
);

// Configure service worker to apply updates automatically
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      // Tell the waiting SW (e.g. v3) to skip waiting and activate immediately
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      
      // Reload the page to load the new cached assets immediately
      window.location.reload();
    }
  },
});

reportWebVitals();